// Room management - create rooms and parse room URLs

export function generateRoomId(): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 6; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export function getRoomIdFromUrl(): string | null {
  const path = window.location.pathname;
  const match = path.match(/^\/room\/([a-z0-9_]+)$/);
  return match ? match[1] : null;
}

export function getTournamentIdFromUrl(): string | null {
  const path = window.location.pathname;
  const match = path.match(/^\/tournament\/([a-z0-9_]+)$/);
  return match ? match[1] : null;
}

export function isTournamentUrl(): boolean {
  return getTournamentIdFromUrl() !== null;
}

export function navigateToRoom(roomId: string): void {
  window.history.pushState({}, '', `/room/${roomId}`);
}

export function isMultiplayerUrl(): boolean {
  return getRoomIdFromUrl() !== null;
}

export function createRoomUrl(roomId: string): string {
  return `${window.location.origin}/room/${roomId}`;
}

export function copyRoomUrl(roomId: string): void {
  const url = createRoomUrl(roomId);
  navigator.clipboard.writeText(url).catch(err => {
    console.error('Failed to copy room URL:', err);
  });
}

// API calls for room management
export async function createRoom(): Promise<string> {
  // In development, API is on different port
  // In production, use the dedicated worker subdomain
  const isDev = window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1');
  const apiHost = isDev ? 'http://localhost:8788' : 'https://wizard-duel-api.neenhouse.workers.dev';

  const response = await fetch(`${apiHost}/api/rooms/create`, {
    method: 'POST',
  });

  if (!response.ok) {
    throw new Error('Failed to create room');
  }

  const data = await response.json();
  return data.roomId;
}

export async function getRoomInfo(roomId: string): Promise<unknown> {
  const isDev = window.location.host.includes('localhost') || window.location.host.includes('127.0.0.1');
  const apiHost = isDev ? 'http://localhost:8788' : 'https://wizard-duel-api.neenhouse.workers.dev';

  const response = await fetch(`${apiHost}/api/rooms/${roomId}`);

  if (!response.ok) {
    throw new Error('Failed to get room info');
  }

  return response.json();
}
